import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import TraceabilityView from "../views/TraceabilityView.vue";
import RecyclableView from "../views/RecyclableView.vue";
import SedimentView from "../views/SedimentView.vue";
import PartnersView from "../views/PartnersView.vue";
import PageView from "../views/PageView.vue";
import ArticleItemView from "../views/ArticleItemView.vue";
import ArticleListView from "../views/ArticleListView.vue";
import Error404View from "../views/Error404View.vue";
import PolicyPrivacyView from "../views/PolicyPrivacyView.vue";
import ContactView from "../views/ContactView.vue";
import ContactResponseView from "../views/ContactResponseView.vue";
import AttitudesAwardView from "../views/AttitudesAwardView.vue";
// import UnderConstructionView from "../views/UnderConstructionView.vue";

Vue.use(VueRouter);

const routes = [
  {
    name: "Início",
    path: "/",
    component: HomeView,
    meta: { keepScrollPosition: true },
  },
  {
    name: "Sobre",
    path: "/sobre",
    component: AboutView,
  },
  {
    name: "Contato",
    path: "/contato",
    component: ContactView,
  },
  {
    name: "Notícias",
    path: "/noticias",
    component: ArticleListView,
  },
  {
    name: "Noticia",
    path: "/noticias/:item",
    component: ArticleItemView,
  },
  {
    name: "Recicláveis",
    path: "/reciclaveis",
    component: RecyclableView,
  },
  {
    name: "Resíduos",
    path: "/residuos",
    component: SedimentView,
  },
  {
    name: "Parceiros",
    path: "/parceiros",
    component: PartnersView,
  },
  {
    name: "Algo a Mais",
    path: "/algoamais",
    component: PageView,
  },
  {
    name: "Obrigado!",
    path: "/contato/obrigado",
    component: ContactResponseView,
  },
  {
    name: "Política de Privacidade",
    path: "/politica-de-privacidade",
    component: PolicyPrivacyView,
  },
  {
    path: "/premio-atitudes",
    name: "Prêmio Atitudes",
    component: AttitudesAwardView,
  },
  {
    name: "Rastreabilidade",
    path: "/rastreabilidade",
    component: TraceabilityView,
  },
  {
    path: "/erro404",
    name: "Erro 404",
    component: Error404View,
  },
  {
    path: "*",
    name: "Erro 404",
    component: Error404View,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    // Verifica se a rota tem a meta "keepScrollPosition" definida como true
    if (to.meta.keepScrollPosition) {
      return savedPosition || false; // Mantém a posição de rolagem ou desabilita a rolagem
    } else if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
